var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodeCta(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4714 4.19528C10.2111 3.93493 9.78895 3.93493 9.5286 4.19528C9.26825 4.45563 9.26825 4.87774 9.5286 5.13809L10.4714 4.19528ZM13.3333 8.00002L13.8047 8.47142C14.0651 8.21108 14.0651 7.78897 13.8047 7.52862L13.3333 8.00002ZM9.5286 10.8619C9.26825 11.1223 9.26825 11.5444 9.5286 11.8048C9.78895 12.0651 10.2111 12.0651 10.4714 11.8048L9.5286 10.8619ZM9.5286 5.13809L12.8619 8.47142L13.8047 7.52862L10.4714 4.19528L9.5286 5.13809ZM12.8619 7.52862L9.5286 10.8619L10.4714 11.8048L13.8047 8.47142L12.8619 7.52862Z",
    fill: "#57606A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52892 11.8048C5.78927 12.0651 6.21138 12.0651 6.47173 11.8048C6.73208 11.5444 6.73208 11.1223 6.47173 10.8619L5.52892 11.8048ZM2.66699 8.00002L2.19559 7.52862C1.93524 7.78896 1.93524 8.21107 2.19559 8.47142L2.66699 8.00002ZM6.47173 5.13809C6.73208 4.87774 6.73208 4.45563 6.47173 4.19528C6.21138 3.93493 5.78927 3.93493 5.52892 4.19528L6.47173 5.13809ZM6.47173 10.8619L3.1384 7.52862L2.19559 8.47142L5.52892 11.8048L6.47173 10.8619ZM3.1384 8.47142L6.47173 5.13809L5.52892 4.19528L2.19559 7.52862L3.1384 8.47142Z",
    fill: "#57606A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCta);
export default __webpack_public_path__ + "static/media/Code_CTA.64a51ef7200e0a6c07ae34ace5342b75.svg";
export { ForwardRef as ReactComponent };